/**
 * Schemes API Endpoints
 * Framework-agnostic endpoint definitions for schemes module
 */

export const SCHEMES_ENDPOINTS = {
  /** Get all schemes */
  list: "scheme/get-scheme",

  /** Create a new scheme */
  create: "scheme/create-scheme-data",

  /** Update scheme date */
  extendDate: "scheme/update-scheme-date",

  /** Get single scheme by ID */
  detail: "scheme/get-scheme",

  /** Update scheme */
  update: "scheme/update-scheme",

  /** Download scheme users Excel */
  downloadUsers: "scheme/download-users",

  /** Get scheme product categories and SKUs */
  productCategory: "scheme/get-brand-category",

  /** Upload scheme user Excel (whitelist) */
  uploadUsers: "users/intermediate-user",

  /** Get spin wheel configurations */
  spinWheels: "spin-wheel/list-spin-config",

  /** Get reward products (EGVs/Merchandise) */
  rewardProducts: "hubadmin/list-product",

  // Maker-Checker endpoints
  /** Get list of generated maker-checker reports */
  makerCheckerList: "loyalty-target/list-maker-check",

  /** Generate new maker-checker report */
  generateMakerChecker: "scheme/scheme-maker-checker",

  /** Upload approved Excel for scheme points */
  uploadApprovedExcel: "scheme/scheme-upload-points",

  /** Reject scheme upload points */
  rejectSchemeUpload: "scheme/reject-scheme-upload-points",
} as const;
